/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import formatTitle from "../common/formatTitle";
import { Button } from "gatsby-material-ui-components";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Img from "gatsby-image";
import Slide from "@material-ui/core/Slide";
import navigation from "../../../content/composants/pages.json";
import PortfolioItem from "./portfolioItem";
import randomKey from "../../helpers/randomKey";

const useStyles = makeStyles((theme) => ({
  regularRow: {
    padding: theme.layout.paddingRegular,
    overflow: "hidden",
  },
  image: {
    overflow: "hidden",
  },
  grow: {
    flexGrow: 1,
    textAlign: "center",
  },
  img: {
    boxShadow: "2px 3px 20px 1px rgb(217 213 217)",
    borderRadius: 10,
  },
  portDesc: {
    margin: 0,
  },
  description: {
    position: "absolute",
    bottom: "20%",
    "@media (min-width:1500px) and (orientation: landscape)": {
      visibility: "hidden",
    },
  },
  onlyDesktop: {
    textAlign: "center",
    visibility: "hidden",
    "@media (min-width:1500px) and (orientation: landscape)": {
      visibility: "visible",
    },
  },
}));

const Portfolio = ({ data, langKey, description, portfolioItems, title }) => {
  const classes = useStyles();
  const [newImage, setNewImage] = useState(true);
  const [index, setIndex] = useState("1");

  const changeIndex = (index) => {
    setNewImage(false);
    setTimeout(() => {
      setIndex(index);
      setNewImage(true);
    }, 100);
  };

  const [softwares, ...rest] = navigation.filter((n) => n.lang === langKey);

  return (
    <Grid
      item
      container
      direction="column"
      className={classes.regularRow}
      justify="center"
      spacing={4}
    >
      <Grid item>
        <Typography variant="h3" style={{ fontWeight: "bold" }}>
          {formatTitle(title)}
        </Typography>
      </Grid>
      <Grid item container direction="row">
        <Grid
          item
          id="img"
          xs={7}
          lg={6}
          style={{ position: "relative", overflow: "hidden", paddingRight: 24 }}
        >
          {newImage && (
            <Slide timeout={500} in direction="right">
              <Img
                fluid={data[`ecran${index}`].childImageSharp.fluid}
                className={classes.img}
                width="100%"
                height="auto"
              />
            </Slide>
          )}
        </Grid>
        <Grid
          item
          xs={5}
          lg={6}
          container
          direction="column"
          style={{ paddingLeft: 24 }}
        >
          {portfolioItems.map((i, idx) => (
            <PortfolioItem
              index={index}
              idx={idx + 1}
              title={i.title}
              content={i.content}
              changeIndex={changeIndex}
              titleColor={i.titleColor}
              key={`indexedDB-${i}-${randomKey()}`}
            />
          ))}

          <Grid item>
            <Button
              color="primary"
              variant="contained"
              size="large"
              fullWidth
              to={`/${langKey}${softwares.items[parseInt(index, 10) - 1].uri}`}
            >
              {`${
                langKey === "fr"
                  ? "Découvrez notre produit"
                  : "Discover our product"
              } ${softwares.items[parseInt(index, 10) - 1].label}`}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

Portfolio.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Portfolio;
